export default "__VITE_ASSET__Bl9FJjT9__"